import { useEffect, useState } from "react";
import { getAllBranch } from "../../services";
import { Branch } from "../../types/user.type";

/**
 * The branch list for the cross-branch cohort's pickers. A branch-scoped user has no picker
 * (the API pins them to the JWT branch), so nothing is fetched for them.
 */
export function useBranches(enabled: boolean): Branch[] {
  const [branches, setBranches] = useState<Branch[]>([]);

  useEffect(() => {
    if (!enabled) return;
    let active = true;
    (async () => {
      try {
        const {
          data: { data },
        } = await getAllBranch();
        if (active) setBranches(Array.isArray(data) ? data : data?.rows ?? []);
      } catch {
        if (active) setBranches([]);
      }
    })();
    return () => {
      active = false;
    };
  }, [enabled]);

  return branches;
}
